import type {CountryCode} from '@commercial-website/data-layer/locale'
import flagAT from '@commercial-website/icons/assets/flags/flag-at.svg'
import flagBE from '@commercial-website/icons/assets/flags/flag-be.svg'
import flagDE from '@commercial-website/icons/assets/flags/flag-de.svg'
import flagDK from '@commercial-website/icons/assets/flags/flag-dk.svg'
import flagEE from '@commercial-website/icons/assets/flags/flag-ee.svg'
import flagES from '@commercial-website/icons/assets/flags/flag-es.svg'
import flagFI from '@commercial-website/icons/assets/flags/flag-fi.svg'
import flagFR from '@commercial-website/icons/assets/flags/flag-fr.svg'
import flagGB from '@commercial-website/icons/assets/flags/flag-gb.svg'
import flagIE from '@commercial-website/icons/assets/flags/flag-ie.svg'
import flagIT from '@commercial-website/icons/assets/flags/flag-it.svg'
import flagLU from '@commercial-website/icons/assets/flags/flag-lu.svg'
import flagNL from '@commercial-website/icons/assets/flags/flag-nl.svg'
import flagNO from '@commercial-website/icons/assets/flags/flag-no.svg'
import flagPT from '@commercial-website/icons/assets/flags/flag-pt.svg'
import flagSE from '@commercial-website/icons/assets/flags/flag-se.svg'
import flagUS from '@commercial-website/icons/assets/flags/flag-us.svg'

// Rebrand flag set (24×24, circular), used by the locale switcher and the getting-started map.
export const countryFlags: Record<CountryCode, string> = {
    gb: flagGB,
    us: flagUS,
    dk: flagDK,
    ee: flagEE,
    es: flagES,
    fr: flagFR,
    de: flagDE,
    se: flagSE,
    ie: flagIE,
    at: flagAT,
    fi: flagFI,
    be: flagBE,
    nl: flagNL,
    it: flagIT,
    pt: flagPT,
    no: flagNO,
    lu: flagLU,
}
